import React from "react";

interface LabelProps {
  label?: string;
  htmlFor?: string;
  isError?: boolean;
}

const Label: React.FC<LabelProps> = ({ label, htmlFor, isError }) => {
  if (!label) return null;
  return (
    <label
      id="general-text"
      className="general-input-label"
      htmlFor={htmlFor}
      style={{
        display: "block",
        marginBottom: "6px",
        fontSize: "14px",
      }}
    >
      <div
        style={{
          color: isError ? "#d92d20" : undefined,
        }}
        dangerouslySetInnerHTML={{ __html: label ?? "" }}
      />
    </label>
  );
};

export default Label;
